import { createTheme } from '@mui/material/styles'

export const defaultTheme = createTheme({
  spacing: 5,
  typography: {
    fontFamily: [
      'Arimo-Regular',
      'Arimo',
      'sans-serif',
    ].join(','),
    fontSize: 14,
  },
  palette: {
    mode: 'dark',
    background: {
      paper: '#000',
      default: '#000',
    },
    primary: {
      main: '#fec010',
      contrastText: '#000',
      light: 'rgba(254, 192, 16, 0.2)',
    },
    secondary: {
      main: '#fbeecb',
      contrastText: '#000',
    },
    error: {
      main: '#d9001b',
    },
    warning: {
      main: '#f26922',
      contrastText: '#000',
    },
    text: {
      primary: '#fff',
      secondary: '#000',
    },
    backgroundColor: {
      main: '#000',
    },
    blackColor: {
      main: '#000',
      light: '#333',
    },
    whiteColor: {
      main: '#fff',
    },
    greyColor: {
      main: '#74777a',
      light: '#d4d4d3',
      dark: '#797979',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          '&.MuiTypography-caption': {
            color: '#fff',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: '#000',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: 13,
          lineHeight: '24px',
          padding: '11px 6px',
          '&.Mui-disabled': {
            color: '#aaa',
            background: '#f2f2f2',
          },
        },
        contained: {
          color: '#74777a',
          background: '#eeeeee',
        },
        containedPrimary: {
          color: '#000',
          background: 'linear-gradient(to right, rgba(249, 191, 18, 0.35) 0%, rgba(249, 191, 17, 0.47) 9%, rgba(249, 191, 16, 0.55) 21%, rgba(253, 191, 16, 0.85) 82%, rgba(253, 191, 16, 0.89) 90%, #fec010 100%)',
        },
        containedSecondary: {
          color: '#000',
          background: '#fbeecb',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontSize: 13,
          color: '#d4d4d3',
          margin: '0',
        },
        label: {
          borderRadius: '47px',
          padding: '5px 7px 5px 15px',
        },

      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color:'#fff',
          padding: '6px',
          backgroundColor: 'rgba(238, 238, 238, 0.5)',
          '&:hover': {
            color: '#000',
            backgroundColor: 'rgba(238, 238, 238, 1)',
          },
          'svg': {
            width: '14px',
            height: '14px',
          },
        },
        colorPrimary: {
          color: '#000',
          background: 'linear-gradient(to right, rgba(249, 191, 18, 0.35) 0%, rgba(249, 191, 17, 0.47) 9%, rgba(249, 191, 16, 0.55) 21%, rgba(253, 191, 16, 0.85) 82%, rgba(253, 191, 16, 0.89) 90%, #fec010 100%)',
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: '#d4d4d3',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: '#fff',
          border: '1px solid #d4d4d3',

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d4d4d3',
          },
        },
        input: {
          padding: '11.5px 14px',
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #fff inset',
            WebkitTextFillColor: '#74777a',
            '&::first-line': {
              fontSize: '1rem',
            },
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#000',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#000',
          color: '#fff',
          fontSize: 14,
        },
        arrow: {
          color: '#000',
        },
      },
    },
  },
})

declare module '@mui/material/styles' {
  interface Palette {
    backgroundColor: Palette['primary']
    blackColor: Palette['primary']
    whiteColor: Palette['primary']
    greyColor: Palette['primary']
  }
  interface PaletteOptions {
    backgroundColor: PaletteOptions['primary']
    blackColor: PaletteOptions['primary']
    whiteColor: PaletteOptions['primary']
    greyColor: PaletteOptions['primary']
  }
}
